import {Button, Kbd, Tooltip, Typography} from "@heroui/react";
import {UndoIcon} from "@project/icons-web";

import {useThemeBuilder} from "./theme-builder-context";

/* ------------------------------------------------------------------------------------------------
 * UndoButton
 * Steps backward through the theme history. Disabled when at the earliest snapshot.
 * ------------------------------------------------------------------------------------------------ */
export function UndoButton() {
  const {canUndo, undo} = useThemeBuilder();

  return (
    <Tooltip closeDelay={0} delay={100}>
      <Tooltip.Trigger>
        <Button isIconOnly isDisabled={!canUndo} size="md" variant="tertiary" onPress={undo}>
          <UndoIcon />
        </Button>
      </Tooltip.Trigger>
      <Tooltip.Content className="flex items-center gap-2">
        <Tooltip.Arrow />
        <Typography>Undo</Typography>
        <Kbd>
          <Kbd.Abbr keyValue="command" />
          <Kbd.Content>Z</Kbd.Content>
        </Kbd>
      </Tooltip.Content>
    </Tooltip>
  );
}
